import React from "react";
import ToolTipComponent from "../ToolTipComponent";
import useMobile from "../../../hooks/useMobile";

export default function Select({
  name,
  id,
  required,
  titleRus,
  message,
  options,
  value,
  onChange,
  onBlock,
  ...props
}) {
  const isMobile = useMobile();

  const handleChange = (e) => {
    if (onBlock) return;
    const selectedIndex = e.target.selectedIndex;
    const optionEntries = Object.entries(options);
    const selectedValue = optionEntries[selectedIndex][1]; // Берём исходное значение для передачи в родительский компонент
    onChange(selectedValue);
  };

  return (
    <div
      id={id}
      className={`form-group ${isMobile ? "form-group-vertical" : ""}`}
    >
      <div className="label-group">
        <label
          htmlFor={id}
          className={`text-s ${required ? `required_${required}` : ""}`}
        >
          {titleRus}
        </label>
        {message && (
          <ToolTipComponent text={message}>
            <div className="icon icon-center help-icon"></div>
          </ToolTipComponent>
        )}
      </div>

      <div className="input-item">
        {Object.keys(options)?.length > 0 && (
          <select
            id={id}
            name={name}
            value={value === null ? "null" : value?.toString()}
            onChange={handleChange}
            required={required === "required" ? true : false}
            className={`text-m
              ${onBlock ? "input-blocked" : ""}
            `}
            {...props}
          >
            {Object.entries(options).map(([optionLabel, optionValue]) => (
              <option
                value={optionValue === null ? "null" : optionValue?.toString()}
                key={optionValue ?? optionLabel}
              >
                {optionLabel}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}
